"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FeatureToggles {
    /** Function to set the json object routes will be checked against */
    static useToggles(jsonObject) {
        FeatureToggles.toggleObject = jsonObject;
    }
    /**
        Function called by Vue when initializing with Vue.use(FeatureToggles),
        this will expose $toggle to the vue instance so that this.$toggle('route') can be used
        or $toggle('route') (in template) without the need for importing FeatureToggles
    */
    static install(Vue) {
        Vue.prototype.$toggle = FeatureToggles.toggle;
    }
    /**
        Function to check for a feature toggle, will always return true except if feature is explicitly set to false.
        The route should be in the form 'some_feature.potential_nested_feature.toggles_can_be_nested_as_much_as_you_want'.
        If the parent to a feature is set to false all children will also return false
    */
    static toggle(route) {
        if (FeatureToggles.toggleObject === undefined)
            return true;
        else if (FeatureToggles.cache.has(route))
            return FeatureToggles.cache.get(route);
        // Route is not trivial and is not yet cached needs to be parsed
        // Cache might not be necessary
        const result = FeatureToggles.__check(route.split('.'), FeatureToggles.toggleObject);
        FeatureToggles.cache.set(route, result);
        return result;
    }
    /** Private function used for recursively searching the json feature toggle object for the given route */
    static __check([field, ...rest], toggleObject) {
        const toggleValue = toggleObject[field];
        switch (toggleValue) {
            case undefined: return true;
            case false: return false;
            default: return toggleValue === true ? toggleValue : FeatureToggles.__check(rest, toggleValue);
        }
    }
}
exports.default = FeatureToggles;
FeatureToggles.cache = new Map();
